
/**
 * 特殊的事件
 */
export interface SpecialEventEntity{
    id : number;
    weight : number;//触发权重
    desc : string;//描述
    modeDefine ?: string;//模式定义
    effectParams ?: { key : number , value : number }[];//影响类型
    chooseArray ?: {chooseItemName:string,desc:string,effectParams :  { key : number , value : number }[] }[];//选项组 数组
}

/**
 * 特殊 事件 定义
 * @constructor
 */
export default function SpecialEventConfig() : SpecialEventEntity[]{
    //数据  数组定义
    const dataArrayDefine : SpecialEventEntity[] = [
        // {
        //     id : 1,
        //     weight: 100,
        //     desc:"你看到公园里面有一百块钱，但是一条疯狗也看见了，跟你抢斗的过程中，你不但钱没有捡到，那负伤看病开药花费100,。",
        //     modeDefine : "公园",
        //     chooseArray:[
        //         {
        //             chooseItemName : "选项1",
        //             desc : "你看到公园里面有50块钱",
        //             effectParams : [{ key:0 ,value : -100 }],
        //         },
        //         {
        //             chooseItemName : "选项2",
        //             desc : "你看到公园里面有100块钱",
        //             effectParams : [{ key:0 ,value : -100 }],
        //         }
        //     ]
        // },
        // {
        //     id : 2,
        //     weight: 100,
        //     desc:"健康突发情况，触发多种并发症，健康值直接掉为0，需要大保健强行续命",
        //     effectParams : [{ key:2 ,value : -100 }]
        // },
        // {
        //     id : 3,
        //     weight: 100,
        //     desc:"健康很差，突发性心机梗塞，没来得及抢救，直接原地去世",
        //     effectParams : [{ key:4 ,value : 1 }]
        // },
    ];

    return dataArrayDefine;
}


